<script>
  import Configuration from "./Configuration.svelte";

  import { Toggle } from "@shopboxai/sb-portal-components";

  import { createEventDispatcher } from "svelte";
  export let notificationsEnabled = false;
  export let selectedPreset = {
    type: "expandable",
    timeout: 300000,
    trigger: "delay",
    showAfter: 100,
    page_type: "",
    collection: "",
    body: "",
    subtitle: "",
    title: "",
    image: "",
  };

  const presets = [
    {
      presetTitle: "Recently viewed on homepage",
      type: "expandable",
      timeout: 10000,
      trigger: "delay",
      showAfter: 600,
      collection: "recent",
      subtitle: " ",
      body: "See recently viewed",
      page_type: "homepage",
    },
    {
      presetTitle: "Recommender on product details",
      type: "expandable",
      timeout: 10000,
      trigger: "delay",
      showAfter: 600,
      collection: "recommended",
      subtitle: " ",
      body: "See recommendations",
      page_type: "productdetails",
    },
    {
      presetTitle: "Similar on product details",
      type: "expandable",
      timeout: 10000,
      trigger: "delay",
      showAfter: 600,
      collection: "similar",
      subtitle: " ",
      body: "See similar products",
      page_type: "productdetails",
    },
  ];

  function handlePresetChange(event) {
    const value = event.target.value;
    if (value === "custom") {
      selectedPreset = {
        type: "expandable",
        timeout: 300000,
        trigger: "delay",
        showAfter: 100,
        page_type: "",
        collection: "",
        body: "",
        subtitle: "",
        title: "",
        image: "",
      };
    } else {
      // @ts-ignore
      selectedPreset = { ...presets[parseInt(value)] };
    }
    handleInput();
  }

  function handlePageTypeChange() {
    if (selectedPreset.page_type === "homepage") {
      selectedPreset.collection = "recent";
    } else if (selectedPreset.page_type === "productdetails") {
      selectedPreset.collection = "similar";
    }
    handleInput();
  }

  const dispatch = createEventDispatcher();
  function handleInput() {
    dispatch("input", true);
  }
</script>

<form>
  <Configuration title="Enable Notifications on mobile" subtitle="">
    <Toggle bind:value={notificationsEnabled} on:input={handleInput} slot="content" />
  </Configuration>
  {#if notificationsEnabled}
    <Configuration title="Start with a Preset" subtitle="">
      <select slot="content" on:change={handlePresetChange}>
        <option value="" disabled selected>Select a preset</option>
        {#each presets as preset, index}
          <option value={index}>{preset.presetTitle}</option>
        {/each}
      </select>
    </Configuration>
    <Configuration title="Page Type" subtitle="What pages the notification will be displayed on">
      <select slot="content" bind:value={selectedPreset.page_type} on:change={handlePageTypeChange}>
        <option value="" disabled selected>Select a page type</option>
        <option value="homepage">Homepage</option>
        <option value="productdetails">Product Detail Page</option>
      </select>
    </Configuration>
    <Configuration title="Collection" subtitle="Select the collection type">
      <select slot="content" bind:value={selectedPreset.collection} on:input={handleInput}>
        <option value="" disabled selected>Select a collection</option>
        {#if selectedPreset.page_type === "homepage"}
          <option value="recent">Recently Viewed</option>
        {:else if selectedPreset.page_type === "productdetails"}
          <option value="similar">Find Similar</option>
          <option value="recommended">Recommended for You</option>
        {/if}
      </select>
    </Configuration>

    <Configuration title="Body text" subtitle="Leave blank to display product price">
      <input slot="content" on:input={handleInput} type="text" bind:value={selectedPreset.body} />
    </Configuration>

    <Configuration title="Subtitle" subtitle="Leave blank to hide subtitle">
      <input slot="content" on:input={handleInput} type="text" bind:value={selectedPreset.subtitle} />
      <p>leave blank for product price</p>
    </Configuration>

    <Configuration title="Title" subtitle="Leave blank to display product title">
      <input slot="content" on:input={handleInput} type="text" bind:value={selectedPreset.title} />
      <p>leave blank for product title</p>
    </Configuration>

    <Configuration title="Image" subtitle="Leave blank to display product image">
      <input slot="content" on:input={handleInput} type="text" bind:value={selectedPreset.image} />
      <p>leave blank for product image</p>
    </Configuration>
  {/if}
</form>

<style>
  input,
  select {
    width: 50%;
    height: 60%;
    border: solid 1px #d0d0d2;
    border-radius: 3px;
    padding: 12px 8px;
  }
</style>
